import { IUseFormStructureItem } from 'modules';
import * as Yup from 'yup';

export type FilterType = {
  transactionIDs: string[];
  refreshData: number;
};

export const initFilterValues: FilterType = {
  transactionIDs: [],
  refreshData: 0,
};

export const filterOptions: IUseFormStructureItem[] = [
  {
    name: 'transactionIDs',
    validate: Yup.string().required('Vui lòng nhập mã giao dịch ngân hàng'),
  },
];

export const convertVariables = (variables: FilterType) => {
  const { transactionIDs, ...rest } = variables;

  const formatCustomerCodes = () => {
    if (!transactionIDs) return [];

    if (Array.isArray(transactionIDs) && transactionIDs.length) {
      return transactionIDs?.map((item) => item);
    }

    return transactionIDs;
  };

  return {
    customerCodes: formatCustomerCodes().toString(),
  };
};
